<template>
  <div class="inspection-grid">
    <div
      v-for="(item, index) in sceneList"
      :key="item.path"
      class="inspection-card"
      @click="toDetail(item)"
    >
      <div class="card-media" :style="{ backgroundImage: 'url(' + item.image + ')' }"></div>
      <div class="card-mask"></div>
      <span class="card-index">{{ formatIndex(index) }}</span>
      <div class="card-content">
        <div class="card-title">{{ item.name }}</div>
        <div class="card-text">{{ item.text }}</div>
        <div class="card-more">
          <img class="item-arrow" src="@/assets/home/item-arrow.png" alt="" />
          <span>进一步了解</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HomePartInspection",
  data() {
    return {
      sceneList: [
        {
          name: "变电站智慧巡检",
          text: "高清视频与轮足式机器人协同守护站内设备",
          image: require("../../zhiHuiXunJian/images/generated-substation.png"),
          path: "/zhxj/substation",
        },
        {
          name: "抽水蓄能站智慧巡检",
          text: "复杂地下空间的连续自主巡检守护",
          image: require("../../zhiHuiXunJian/images/generated-pumped.png"),
          path: "/zhxj/pumped",
        },
        {
          name: "数据机房智慧巡检",
          text: "本地安全可控的机房智能运维体系",
          image: require("../../zhiHuiXunJian/images/generated-datacenter.png"),
          path: "/zhxj/datacenter",
        },
        {
          name: "高速公路智慧巡检",
          text: "空地协同，让道路风险更早被发现",
          image: require("../../zhiHuiXunJian/images/generated-highway.png"),
          path: "/zhxj/highway",
        },
        {
          name: "工业园区智慧巡检",
          text: "动静结合，构建园区全域安全感知",
          image: require("../../zhiHuiXunJian/images/generated-park.png"),
          path: "/zhxj/park",
        },
        {
          name: "矿山智慧巡检",
          text: "空地一体的矿区风险感知与闭环管理",
          image: require("../../zhiHuiXunJian/images/generated-mine.png"),
          path: "/zhxj/mine",
        },
      ],
    };
  },
  methods: {
    formatIndex(index) {
      return "0" + (index + 1);
    },
    toDetail(item) {
      if (this.$route.path != item.path) {
        this.$router.push({
          path: item.path,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.inspection-grid {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 0 160px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(2, 1fr);
  gap: 24px;
}

.inspection-card {
  min-width: 0;
  position: relative;
  overflow: hidden;
  border-radius: 18px;
  cursor: pointer;
  box-shadow: 0 12px 30px rgba(18, 68, 145, 0.12);
  transition: transform 0.3s, box-shadow 0.3s;

  &:hover {
    transform: translateY(-6px);
    box-shadow: 0 22px 46px rgba(18, 68, 145, 0.22);

    .card-media {
      transform: scale(1.06);
    }

    .card-mask {
      background: linear-gradient(
        180deg,
        rgba(4, 27, 70, 0.12) 0%,
        rgba(4, 27, 70, 0.62) 48%,
        rgba(3, 22, 58, 0.92) 100%
      );
    }

    .card-more {
      opacity: 1;
      transform: translateY(0);
    }
  }
}

.card-media {
  position: absolute;
  inset: 0;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  transition: transform 0.5s;
}

.card-mask {
  position: absolute;
  inset: 0;
  background: linear-gradient(
    180deg,
    rgba(4, 27, 70, 0) 0%,
    rgba(4, 27, 70, 0.42) 52%,
    rgba(3, 22, 58, 0.86) 100%
  );
  transition: background 0.3s;
}

.card-index {
  position: absolute;
  z-index: 2;
  top: 26px;
  left: 30px;
  color: rgba(255, 255, 255, 0.85);
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 1px;

  &::after {
    content: "";
    width: 26px;
    height: 2px;
    position: absolute;
    top: 11px;
    left: 32px;
    background: #ffffff;
    opacity: 0.6;
  }
}

.card-content {
  position: absolute;
  z-index: 2;
  right: 30px;
  bottom: 30px;
  left: 30px;
  color: #ffffff;
}

.card-title {
  margin-bottom: 12px;
  font-size: 24px;
}

.card-text {
  margin-bottom: 16px;
  color: rgba(255, 255, 255, 0.78);
  font-size: 15px;
  line-height: 26px;
}

.card-more {
  display: flex;
  align-items: center;
  font-size: 16px;
  opacity: 0;
  transform: translateY(8px);
  transition: opacity 0.3s, transform 0.3s;

  .item-arrow {
    width: 28px;
    height: 18px;
    margin-right: 10px;
  }
}

@media (max-width: 1500px) {
  .inspection-grid {
    padding: 0 80px;
    gap: 18px;
  }

  .card-title {
    font-size: 21px;
  }

  .card-text {
    font-size: 14px;
    line-height: 24px;
  }
}

@media (max-width: 1100px) {
  .inspection-grid {
    padding: 0 24px;
  }

  .card-content {
    right: 20px;
    bottom: 22px;
    left: 20px;
  }

  .card-index {
    top: 18px;
    left: 20px;
  }
}
</style>
